import { MouseEvent, useState } from 'react';

import { AnyValuesDistinctItem } from '@api/catalog';

import Checkbox from '@controls/Checkbox';
import CheckboxGroup from '@controls/CheckboxGroup';
import BasicField from '@controls/Form/BasicField';

import { colors, scale } from '@scripts/gds';

import SearchIcon from '@icons/24/search.svg';

import CheckboxGroupCategory from './CheckboxGroupCategory';
import { FilterItem } from './types';

interface CheckboxSearchProps {
    items?: FilterItem[];
    withSearch: boolean;
    anyCollection?: {
        isAnyCollection?: boolean;
        items?: AnyValuesDistinctItem[];
        isCategory?: boolean;
    };
    values?: {
        [key: string]: unknown[];
    };
}

const CheckboxSearch = ({
    items,
    withSearch,
    anyCollection = {
        isAnyCollection: false,
        items: [],
        isCategory: false,
    },
    ...props
}: CheckboxSearchProps) => {
    const [search, setSearch] = useState('');

    const filterItems = items?.map(item => {
        const name = item.value ? item.value : item.name;
        const transformedName = name === 'false' ? 'нет' : name === 'true' ? 'да' : name;

        return {
            ...item,
            name: transformedName,
        };
    });

    return (
        <>
            {withSearch ? (
                <BasicField
                    Icon={SearchIcon}
                    placeholder="Найти..."
                    value={search}
                    css={{
                        '> input': {
                            border: `1px solid ${colors.borderMain}`,
                            borderRadius: scale(1, false, 6),
                            paddingLeft: scale(1),
                        },
                        marginBottom: scale(1, true),
                    }}
                    onChange={(e: MouseEvent<HTMLInputElement>) => {
                        setSearch((e.target as HTMLInputElement).value.toLowerCase());
                    }}
                />
            ) : (
                ''
            )}

            <div
                css={{
                    maxHeight: scale(20),
                    overflowY: 'auto',
                    '::-webkit-scrollbar': {
                        width: 3,
                        backgroundColor: '#E0E5E7',
                        maxHeight: scale(1, true),
                        '&-thumb': {
                            backgroundColor: colors.textSecondGrey,
                        },
                    },
                }}
            >
                <CheckboxGroup {...props}>
                    {anyCollection.isAnyCollection ? (
                        <CheckboxGroupCategory withSearch anyCollection={anyCollection}></CheckboxGroupCategory>
                    ) : (
                        filterItems?.map(item => (
                            <Checkbox
                                value={item.code}
                                key={item.code + item.name}
                                css={{
                                    marginTop: scale(1),
                                    display: item.name?.toLowerCase().includes(search) ? 'block' : 'none',
                                }}
                            >
                                {item.name}
                            </Checkbox>
                        ))
                    )}
                </CheckboxGroup>
            </div>
        </>
    );
};

export default CheckboxSearch;
